import React from 'react';
import {
    withStyles,
    Grid, 
    ButtonBase,
    Typography, 
    Modal,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"
 
import AppUtils from '../../control/apputlis'; 
 
const ICON_CLOSE = require("../../images/icons/guanbi.png");
const ICON_MASK = require('../../images/bg/mask.png');

 
class IntegralBuy extends React.Component {


    constructor(props) {
        super(props); 
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'IntegralBuy');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }


    render() {
        const { classes, open, good } = this.props;  
        return (
            <Modal
                open={open}
                hideBackdrop={true}
                onClose={() => this.props.onClose()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                className={classes.modal}
                style={{ position: 'fixed', top: 0, width: '100vw' }}
            >
                <Grid container direction='column' alignItems='center' justify='center' className={classes.root}>
                    <Grid container direction='column' alignItems='center' justify='center' className={classes.container}>
                        <img src={good.cover} style={{ marginTop: 20, marginBottom: 20, width: 200, height: 200 }} />
                        <Grid container direction='column' style={{ paddingLeft: 24, paddingRight: 24 }}>
                            <Typography style={{ fontSize: 17, color: '#2F2F2F' }}>{good.name}</Typography>
                            <Typography style={{ fontSize: 12, color: '#919191', marginTop: 4 }}>{good.info}</Typography>

                            <Grid container direction='row' alignItems='center' style={{ marginTop: 4 }} >
                                <Typography style={{ fontSize: 12, color: '#FF0000' }}>
                                    {good.score + "积分"}
                                </Typography>
                                <Typography style={{ fontSize: 12, color: '#919191', marginLeft: 24,textDecoration:'line-through' }}>
                                    {good.show_score + "积分"}
                                </Typography>
                            </Grid>
                            <ButtonBase onClick={() => this.props.onExchange(good)} className={classes.button}>兑换</ButtonBase>
                            <Typography style={{ fontSize: 12, color: '#919191', marginBottom: 12 }}>使用积分兑换后，不可撤销</Typography>
                        </Grid>
                    </Grid>
                    <Grid style={{ marginTop: 32 }}>
                        <ButtonBase onClick={() => this.props.onClose()}>
                            <img src={ICON_CLOSE} style={{ width: 32, height: 32 }}></img>
                        </ButtonBase>
                    </Grid>
                </Grid>
            </Modal >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    modal: {
        backgroundColor: 'transparent',
        width: '100vw',
        height: '100vh',
    },
    root: {
        backgroundImage: `url(${ICON_MASK})`,
        width: '100vw',
        height: '100vh',
    },
    container: {
        backgroundColor: '#FFF',
        borderRadius: 20,
        width: 'calc(100vw - 80px)',
    },
    button: {
        background: '#007AFF',
        borderRadius: 10,
        color: 'white',
        height: 45,
        width: "100%",
        margin: theme.spacing(2, 0, 2, 0),
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
    }
}))(IntegralBuy));